import { BackendModel } from "../../backend/models/BackendModel"
import { ChannelModel } from "../../channel/models/ChannelModel"

export class SubscriberForgottenInfoModel {
    products:string|number = 0
    categories:string|number = 0
    brands:string|number = 0
    orders:string|number = 0
    channels: ChannelModel[] = []
    backend: BackendModel = new BackendModel()

    constructor(s?:Partial<SubscriberForgottenInfoModel>) {
        Object.assign(this, s)   

        this._parseChannels()
        this._parseBackend()
        this._parseQuantities()
    }

    private _parseChannels():void {
        this.channels = this.channels.map(c => new ChannelModel(c))
    }
    
    private _parseBackend():void {
        this.backend = new BackendModel(this.backend)
    }

    private _parseQuantities():void {
        this.products = Number(this.products)
        this.categories = Number(this.categories)
        this.brands = Number(this.brands)
        this.orders = Number(this.orders)
    }
}
